function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    }
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.008 13.676c.851 0 1.567-.58 1.78-1.354h7.875v-.968h-7.875A1.851 1.851 0 0 0 11.008 10a1.85 1.85 0 0 0-1.838 1.838c0 1.026.832 1.838 1.838 1.838ZM18.998 16.732c-.851 0-1.567.581-1.78 1.355H9.285v.967h7.933a1.852 1.852 0 0 0 1.78 1.355 1.85 1.85 0 0 0 1.838-1.838 1.85 1.85 0 0 0-1.838-1.839Z",
    style: {
      fillRule: "nonzero"
    },
    transform: "translate(-9.17 -10)"
  }));
};
export default SvgFilter;